// Titles and descriptions for every public URL. The app applies them to the <head> as you
// move around (usePageMeta), and scripts/seo.mjs writes them into a static HTML file per
// URL at build time, so search engines and link previews see them without running JavaScript.
// Keep this file free of imports: the build script loads it on its own.

export const SITE_URL = "https://diarmuid.dev";
export const SITE_NAME = "Diarmuid Hession";
export const OG_IMAGE = `${SITE_URL}/og-image.png`;

export const DEFAULT_META = {
  title: "Diarmuid Hession | Full-Stack Software Developer, Ireland",
  description:
    "Diarmuid Hession is a full-stack software developer and final-year Software student at ATU Sligo, Ireland, building computer vision, web and cloud systems.",
  path: "/",
};

// Standalone pages
export const PAGE_META = {
  "/cv": {
    title: "CV | Diarmuid Hession, Software Developer",
    description:
      "The CV of Diarmuid Hession: software engineering at the Department of Social Protection, First Class Honours in 3rd year at ATU Sligo, projects and skills.",
  },
  "/weather": {
    title: "Weather Pulse | Diarmuid Hession",
    description:
      "Weather Pulse, a React weather app by Diarmuid Hession that shows live conditions and forecasts from the OpenWeather API for any city.",
  },
  "/chat": {
    title: "Ask about Diarmuid Hession | Chat assistant",
    description:
      "Ask an AI assistant about Diarmuid Hession's projects, work experience, skills and education, with links to the full write-ups.",
  },
};

// Search results show about 155 characters; cut at a word rather than mid-word
export function clip(text, max = 155) {
  const clean = String(text || "").replace(/\s+/g, " ").trim();
  if (clean.length <= max) return clean;
  return `${clean.slice(0, clean.lastIndexOf(" ", max - 1)).replace(/[,;:.\s]+$/, "")}…`;
}

export function projectMeta(project, slug) {
  return {
    title: `${project.title} | Diarmuid Hession`,
    description: clip(project.description),
    path: `/projects/${slug}`,
  };
}

export function certificateMeta(certificate) {
  const date = new Date(`${certificate.completed}T12:00:00Z`).toLocaleDateString("en-IE", {
    day: "numeric", month: "long", year: "numeric", timeZone: "UTC",
  });
  return {
    title: `${certificate.title} | Diarmuid Hession`,
    description: clip(`Diarmuid Hession's certificate for ${certificate.title}, from ${certificate.issuer}, completed ${date}.`),
    path: `/certificates/${certificate.slug}`,
  };
}
